/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DetalleEncuestaModelDto } from '../../models/detalle-encuesta-model-dto';

export interface EncuestasControllerGetDetalleEncuestaPaciente$Params {
  uuidEncuesta: string;
}

export function encuestasControllerGetDetalleEncuestaPaciente(http: HttpClient, rootUrl: string, params: EncuestasControllerGetDetalleEncuestaPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DetalleEncuestaModelDto>>> {
  const rb = new RequestBuilder(rootUrl, encuestasControllerGetDetalleEncuestaPaciente.PATH, 'get');
  if (params) {
    rb.path('uuidEncuesta', params.uuidEncuesta, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DetalleEncuestaModelDto>>;
    })
  );
}

encuestasControllerGetDetalleEncuestaPaciente.PATH = '/api/paciente-encuestas/detalle-encuesta-paciente/{uuidEncuesta}';
